// Open/Close Bubble on click

export default {
    data() {
        return {
            show: {
                bubble: false,
            },
            lastClick: ''
        }
    },
    created() {
        document.addEventListener('click', this.documentClick)
    },
    destroyed() {
        document.removeEventListener('click', this.documentClick)
    },
    methods: {
        documentClick(e) {
            let target = e.target
            var el = this.$refs.bubble
            if (target && el) {
                 if ( (el !== target) && !el.includes(target)) {
                    this.show.bubble=false
                }
            }
        },
        bubbleClick (id) {
            if (!this.show.bubble)
            {
                this.lastClick = id
                this.show.bubble=true
            }
            else{
                if(this.lastClick == id)
                {
                    this.show.bubble =false
                }
                else{
                    this.lastClick = id
                }

            }
        },
        bubbleAction (id) {
            if (this.show.bubble && this.lastClick == id) { return true }
        },
    }
}